<template>
  <div>
    <div
      class="mb-5 rounded border-l-4 border-yellow-300 bg-yellow-50 p-4 text-yellow-800"
      role="alert"
    >
      <p class="font-bold">
        Warning!
      </p>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockedAlert',

  props: {
    message: {
      type: String,
      required: true,
    },
  },
}
</script>
